// FILE: asgur-pwa/src/index.js
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
// Nanti Anda perlu membuat file index.css untuk setup Tailwind CSS
// import './index.css'; 
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();